/*
 * スクロールに応じた表示アニメーション
 *
 * 旧テーマ application.js の fadeAnime()（jQuery + scrollイベントで
 * 毎回 offset を計算）を IntersectionObserver に置き換えたもの。
 * スクロールのたびに全要素のレイアウトを測らずに済む。
 */
(function () {
  'use strict';

  var SELECTOR = '.iroiro-anim-fade, .iroiro-anim-fade-up, .iroiro-anim-flowing, .iroiro-anim-rise';

  var DEFAULT_OFFSET = 10; // 画面下から何%まで上がったら出すか
  var SUPPORTED = 'IntersectionObserver' in window;

  /*
   * 発火位置はレイアウトによって適切な値が変わる。
   *
   * 貼り付く2カラムでは遅らせたいが、同じ値を縦積みに持ち込むと、
   * 縦に長い写真列を抜けたあと何も無い領域を延々スクロールすることになる。
   * data-iroiro-anim-offset-narrow があれば、狭い幅ではそちらを使う。
   */
  var WIDE = '(min-width: 1024px)';

  function offsetOf(el) {
    var wide = window.matchMedia(WIDE).matches;
    var raw = wide ? el.dataset.iroiroAnimOffset : el.dataset.iroiroAnimOffsetNarrow;
    if (raw === undefined || raw === '') raw = el.dataset.iroiroAnimOffset;
    var value = parseInt(raw, 10);
    if (isNaN(value) || value < 0 || value > 90) return DEFAULT_OFFSET;
    return value;
  }

  /*
   * 発火位置ごとに観測者を分ける。
   *
   * rootMargin は観測者ごとの設定なので、要素によって出るタイミングを
   * 変えたい場合は観測者自体を分ける必要がある。
   * data-iroiro-anim-offset で % を指定でき、大きいほど遅く出る。
   *
   * 貼り付く（position: sticky）要素を含むセクションで効いてくる。
   * 貼り付く箱は本来の位置より早く画面に入るため、既定の10%だと
   * セクションが到着しきる前に出てしまう。
   */
  var groups = new Map(); // offset → { observer, watched }

  function groupFor(offset) {
    var existing = groups.get(offset);
    if (existing) return existing;

    var group = {
      // 監視対象の要素 → クラスを付け外しする要素のリスト
      watched: new Map(),
      observer: null
    };
    group.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              /*
               * 旧テーマの判定（scroll >= elemPos - windowHeight）を再現する。
               * 「画面に入った」または「すでに上に抜けた」なら表示、
               * 「まだ画面より下」なら非表示。
               *
               * 上に抜けたときに非表示へ戻すと、スクロールのたびに
               * アニメーションが再生され直してちらつく。
               * 逆に上に抜けた場合を表示扱いにしないと、素早いスクロールで
               * 交差イベントを踏まずに通過した要素が opacity:0 のまま残る。
               */
              var show = entry.isIntersecting || entry.boundingClientRect.top < 0;
              var targets = group.watched.get(entry.target);
              if (!targets) return;
              targets.forEach(function (el) {
                el.classList.toggle('is-visible', show);
              });
            });
          },
          { rootMargin: '0px 0px -' + offset + '% 0px' }
        );

    groups.set(offset, group);
    return group;
  }

  /*
   * IntersectionObserver は面積が 0 の要素を交差と判定しない。
   * 「横に流れて出る」演出は幅 0 から始まるため、そのまま監視すると
   * いつまでも発火しない。大きさを持つ最も近い祖先を監視対象にする。
   * （旧テーマは offset().top で測っていたので幅 0 でも動いていた）
   */
  function probeFor(el) {
    /*
     * data-iroiro-anim-probe があれば、その祖先を監視対象にする。
     *
     * 中身を箱の中で縦中央に置いていると、要素自身の位置は箱の高さで
     * 決まってしまい、セクションの到着とは無関係にずれる。
     * 箱を見れば、中身をどこに置いても到着したときに出る。
     */
    var selector = el.dataset.iroiroAnimProbe;
    if (selector) {
      var explicit = el.closest(selector);
      if (explicit) return explicit;
    }

    var node = el;
    while (node && node !== document.body) {
      var rect = node.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return node;
      node = node.parentElement;
    }
    return el;
  }

  function observe(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.iroiroAnimReady === 'true') return;
      el.dataset.iroiroAnimReady = 'true';

      // IntersectionObserver が使えない環境では最初から表示しておく
      if (!SUPPORTED) {
        el.classList.add('is-visible');
        return;
      }

      var group = groupFor(offsetOf(el));
      var probe = probeFor(el);
      var targets = group.watched.get(probe);
      if (targets) {
        targets.push(el);
        return;
      }
      group.watched.set(probe, [el]);
      group.observer.observe(probe);
    });
  }

  function init() {
    observe(document);
    // 画像の読み込みでレイアウトが変わると面積が確定するため、再度拾い直す
    window.addEventListener('load', function () {
      observe(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションを編集したときに拾い直す
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
